import imgSrc from "assets/images/placeholder.png";

export const faqContent = [
  {
    img: imgSrc,
    title: "Who is behind Doge? ",
    desc: "The Doge team is a group of NFT and blockchain gaming enthusiasts who want to expand opportunities in the play to earn revolution. We have been NFT OGs since 2017 and believe in the vision of free and open financial infrastructures. ",
  },
  {
    img: imgSrc,
    title: "What do I get?",
    desc: "After buying a Doge NFT, community membership on Discord will be unlocked and you will have access to our network of pro gamers, crypto investors and marketing/streaming experts. We also do giveaways and exclusive events on our Discord server, which you will have privileged access to.",
  },
  {
    img: imgSrc,
    title: "Why doge?",
    desc: "Doge NFT proceeds will go towards creating new scholarship opportunities for aspiring gamers. Scholarship programs are spread over several popular play to earn blockchain games. Our community is made up of gamers, creators, investors and digital art enthusiasts. This unique combination of people offers a vibrant space to meet new friends and collaborate. ",
  },
  {
    img: imgSrc,
    title: "What's on the roadmap?",
    desc: "Our roadmap goals include releasing the collection, educational events for the community, rewards programs, NFT launchpad, physical meetups and more. Our engineering team is hard at work on all of this and you can see our expected timeline below. ",
  },
];
